import { render, staticRenderFns } from "./GroupRecipientsListableManager.vue?vue&type=template&id=0472f31b&scoped=true&"
import script from "./GroupRecipientsListableManager.vue?vue&type=script&lang=js&"
export * from "./GroupRecipientsListableManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472f31b",
  null
  
)

export default component.exports